import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["input", "toggleButton", "hideIcon", "showIcon"]

  connect() {
    this.isVisible = false
  }

  get hiddenClass() {
    return "c-form--password_field_label_outside-form__toggle-icon--is-hidden"
  }

  toggle(event) {
    event.preventDefault()
    this.isVisible = !this.isVisible

    if (this.isVisible) {
      this.showPassword()
    } else {
      this.hidePassword()
    }
  }

  showPassword() {
    this.inputTarget.type = "text"
    this.toggleButtonTarget.setAttribute("aria-label", "Hide password")
    this.hideIconTarget.classList.add(this.hiddenClass)
    this.showIconTarget.classList.remove(this.hiddenClass)
  }

  hidePassword() {
    this.inputTarget.type = "password"
    this.toggleButtonTarget.setAttribute("aria-label", "Show password")
    this.hideIconTarget.classList.remove(this.hiddenClass)
    this.showIconTarget.classList.add(this.hiddenClass)
  }
}
